import CompanyGroup from 'models/Profile/CompanyGroups';

function groupCompaniesGroupById(groups : Array<CompanyGroup>) : Array<CompanyGroup> {
  const companyGroup : Array<CompanyGroup> = [];

  groups.forEach((group) => {
    if(!group) return;
    if(hasGroup(companyGroup, group)) return;

    if(!group.companies)
      group.companies = [];

    companyGroup.push(group);
  });

  return companyGroup;
}

function hasGroup(groups : Array<CompanyGroup>, currentGroup : CompanyGroup) : boolean {
  return groups.some(group => group.groupId === currentGroup.groupId && group.groupName === currentGroup.groupName);
}

export default groupCompaniesGroupById;